import { connectRouter } from "connected-react-router";
import { combineReducers } from "redux";
import analytics from "./analytics";
import auth from "./auth";
import loading from "./loading";
import notification from "./notification";
import resources from "./resource";
import ui from "./ui";

export default (customReducers, history) =>
  combineReducers({
    resources,
    loading,
    ui,
    auth,
    notification,
    analytics,
    router: connectRouter(history),
    ...customReducers,
  });
